export class CampaignLaunchPreconditionError extends Error {
  constructor() {
    super('Campaign launch settings changed before the launch could be committed.');
    this.name = 'CampaignLaunchPreconditionError';
    this.code = 'campaign-launch-precondition-failed';
  }
}

export async function commitGuardedFirestoreTransaction({
  db,
  runTransaction,
  guardRef,
  validateCurrent,
  applyWrites,
}) {
  return runTransaction(db, async transaction => {
    const currentSnapshot = await transaction.get(guardRef);
    let isCurrent = false;
    if (currentSnapshot.exists()) {
      try {
        isCurrent = validateCurrent(currentSnapshot.data()) === true;
      } catch (_error) {
        isCurrent = false;
      }
    }
    if (!isCurrent) throw new CampaignLaunchPreconditionError();
    return applyWrites(transaction);
  });
}
